<template>
  <div class="air_conditioner_form">
    <div class="tit">
      <span>
        <router-link to="/personal_center/enterprise/property_services/air_conditioner/table_list" class="back">
          <i class="el-icon-arrow-left"></i>
        </router-link>空调安维申请详情
      </span>
    </div>
     <div class="body_content">
      <table class="contract_table">
        <tr>
          <th colspan="4">基本情况</th>
        </tr>
        <tr>
          <td>单号</td>
          <td>{{params.code}}</td>
          <td>状态</td>
          <td>{{params.status_name}}</td>
        </tr>
        <tr>
          <td>申请单位名称</td>
          <td colspan="3">{{params.company}}</td>
        </tr>
        <tr>
          <td>所在楼栋</td>
          <td>{{params.building_name}}</td>
          <td>合同房号</td>
          <td>{{params.unit_code}}</td>
        </tr>
        <tr>
          <td>经办人</td>
          <td>{{params.contact}}</td>
          <td>手机号</td>
          <td>{{params.contact_phone}}</td>
        </tr>
        <tr>
          <td>意向预约时间</td>
          <td>{{params.plan_date}}</td>
          <td>提交时间</td>
          <td>{{params.apply_date}}</td>
        </tr>
        <tr>
          <th colspan="4">预审批意见</th>
        </tr>
        <tr>
          <td>预审批人</td>
          <td>{{params.release_examine_name}}</td>
          <td>预审批时间</td>
          <td>{{params.release_examine_date}}</td>
        </tr>
        <tr>
          <td>审批意见</td>
          <td>{{params.release_examine_remark}}</td>
          <td>确定预约时间</td>
          <td>{{params.examine_plan_date}}</td>
        </tr>
        <template v-if="params.status === 70">
          <tr>
            <th colspan="4">完成情况</th>
          </tr>
          <tr>
            <td>装修工程跟进人</td>
            <td>{{params.execute_name}}</td>
            <td>完成时间</td>
            <td>{{params.execute_date}}</td>
          </tr>
          <tr>
            <th colspan="3">情况描述</th>
          </tr>
          <tr>
            <td>情况描述</td>
            <td colspan="3">{{params.execute_remark}}</td>
          </tr>
        </template>
      </table>
    </div>
  </div>
</template>

<script>
import changeMobile from "@/components/changeMobile/change_mobile";
import uploadImg from "@/components/file_upload/uploadImg.vue";
export default {
  components: {
    changeMobile,
    uploadImg
  },
  data() {
    return {
      params: {
        vrv_project_type: "",
        vrv_type:''
      },
      buildings: [], //楼盘
      loading: false,
      type: [
      {name:'挂式空调',val:10},
      {name:'立式空调',val:20},
      {name:'天花机空调',val:30},
    ], //空调类型
    proType:[
      { name:'空调安装',val:10},
      { name:'空调维修',val:20},
    ],
      apiParams2: {
        params: {
          //文件上传所需要的参数
          catalog: "CatalogUserHead",
          loginKey: ""
        },
        imgPath: "release_images_paths", //文件路径字段
        fileId: "release_images" //文件id字段
      }
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    },
    parkInfo() {
      return this.$store.state.parkInfo;
    },
    company() {
      return this.$store.state.company;
    }
  },
  created() {
    if (this.parkInfo) {
      this.initPage();
    } else {
      this.needInfo("parkInfo", "initPage");
    }
  },
  methods: {
    /* 监测信息 */
    needInfo(name, fn) {
      let watchAch = this.$watch(name, (val, oldVal) => {
        if (val) {
          this[fn] && this[fn]();
          watchAch(); //取消监听
        }
      });
    },
    initParams() {
      this.params = Object.assign({}, this.params, {
        company: this.company
      });
    },
    initPage() {
      this.getBuildings(); //条件查询楼盘（前台）
      this.getList(); //编辑数据
    },
    //条件查询楼盘（前台）
    getBuildings() {
      let params = {
        incubator: this.parkInfo.id,
        pageSize: 999
      };
      this.api.getBuildings(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        this.buildings = res.obj.list;
      });
    },
    /** 列表*/
    getList() {
      if (!this.$route.query.id) {
        if (this.company) {
          this.initParams();
        } else {
          this.needInfo("parkInfo", "initParams");
        }
        return;
      }
      let params = Object.assign({}, this.layerpageinfo, this.form, {
        id: this.$route.query.id,
        incubator: this.parkInfo.id
      });
      this.api.getApply(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        let obj = res.obj.list[0] || null;
        if (obj) {
          this.params = Object.assign({}, this.params, obj);
        }
      });
    },
    /** 提交表单验证*/
    submit(type) {
      this.$refs["myform"].validate(valid => {
        if (valid) {
          this.save(type);
        } else {
          this.$message.info("请检测必填项!");
          return false;
        }
      });
    },
    /** 保存表单内容*/
    save(type) {
      let params = Object.assign({}, this.params, {
        incubator: this.parkInfo.id,
        id: this.$route.query.id || "",
        types: "10"
      });
      this.api.submitApply(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        this.$message.success("操作成功");
        this.$router.push({
          name: "enterprise_air_conditioner_table_list"
        });
      });
    },
    go(name) {
      this.$router.push({
        name: name
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.air_conditioner_form {
  h2 {
    font-weight: 700;
    font-size: 20px;
    text-align: center;
    line-height: 40px;
  }
  .my_row {
    text-align: center;
    line-height: 30px;
  }
  p {
    padding: 20px;
    border: 1px solid #999;
    font-size: 14px;
    line-height: 20px;
    background: #f0f0f0;
  }
  .imgList {
    display: flex;
    img {
      width: 80px;
      height: 80px;
    }
  }
  .contract_table {
    width: 100%;
  }
  .contract_table,
  tr,
  td {
    border: 1px solid #eee;
  }
  th {
    font-weight: 700;
    background: #f0f0f0;
  }
  td,
  th {
    padding: 10px 10px;
    font-size: 14px;
    color: #666;
    line-height: 20px;
    min-width: 120px;
    vertical-align: middle;
  }
  .tit {
    .back {
      display: inline-block;
      width: 38px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      border: 1px solid #dcdfe6;
      margin-right: 14px;
      cursor: pointer;
      vertical-align: middle;
    }
  }
}
</style>